import { doNothingAction } from "../../common/action/doNothingAction";
import { GEOMETRY_CHANGED, GeometryChangedAction } from "../../editFeature/redux/geometryChanged/geometryChangedAction";
import { portalDispatcher } from "../dispatcher";
import { EpicFactory } from "../../core/core-redux/reduxTypes";
import { Action } from "redux";
import { RootState } from "../../rootState";
import { ChangeTypes } from "../../editFeature/util/geometry/types";

export const updateFeatureGeometryOnPortalEpic: EpicFactory<Action, RootState, Action> = (action$) =>
    action$.ofType<GeometryChangedAction>(GEOMETRY_CHANGED).map((action) => {
        let changes = action.change.filter(
            (change) => change.type !== ChangeTypes.SEGMENT_CHANGED || change.segment !== undefined
        );

        if (changes.length > 0) {
            portalDispatcher.updateFeatureGeometry(changes, action.changedFeature);
        }

        return doNothingAction();
    });
